import React from "react";
import logo from "../../Assets/T&T_Logo.png";
import curve from "../../Assets/curve1.png";
// import WcardBg from "../../Assets/W-Card Bg.png";
import cardBg from "../../Assets/TTC_bg.png";
import { jsPDF } from "jspdf";

const RightSideContent = ({ data }) => {
  // Generate warranty numbers for all cards and memoize them
  // const warrantyNumbers = useMemo(() => {
  //   return data.map(() => "TT"+Math.floor(1000 + Math.random() * 999000));
  // }, [data]);

  // const warrantyNumbers = useMemo(() => {
  //   return data.map((_, index) => {
  //     const warrantyNumber = 1000 + index; // Sequential numbering starts at 1000
  //     return warrantyNumber > 999999 ? 999999 : warrantyNumber; // Limit to 6 digits
  //   });
  // }, [data]);

  // Function to format the date as DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A"; // Handle empty date
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // en-GB gives DD/MM/YYYY
  };

  const generatePDF = async (name) => {
    const customWidth = 148; // Width in mm
    const customHeight = 210; // Height in mm

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [customWidth, customHeight],
    });

    let isFirstPage = true;

    for (let index = 0; index < data.length; index++) {
      const card = data[index];

      // Add new page if not the first page
      if (!isFirstPage) {
        pdf.addPage();
      }

      // Add Logo and Curve images
      const imgWidth = 130; // Background image width
      const imgHeight = 100; // Background image height

      const imgX = (customWidth - imgWidth) / 2; // Center horizontally
      const imgY = (customHeight - imgHeight) / 2; // Center vertically (if needed)

      // Add Background Image (Centered)
      pdf.addImage(cardBg, "PNG", imgX, imgY, imgWidth, imgHeight); // Adjust size and position as needed
      // pdf.addImage(curve, "PNG", 150, 10, 50, 15); // Adjust position
      // pdf.addImage(WcardBg, "PNG", 0, 150, 210, 100);
      //
      pdf.setFont("Helvetica", "normal");
      pdf.setFontSize(6);

      // Set the color for the first paragraph
      // pdf.setTextColor(255, 0, 0); // Red color for the first paragraph

      const firstParagraph =
        "Thank you for beginning this journey with Track and Trail. Our products are thoughtfully designed with your needs in mind, enabling you to live a fuller and more empowered life. This product is covered by a 2-year warranty from the date of purchase against manufacturing defects. Please note that the warranty does not cover misuse, physical damage, or water ingress.";

      // Automatically split the text into multiple lines
      const firstLines = pdf.splitTextToSize(firstParagraph, 110); // Adjust width to control text box size

      // Define line height
      const lineHeight = 3; // Adjust line height as needed

      // Render the first paragraph with custom color
      let yPosition = 75; // Starting Y-coordinate
      firstLines.forEach((line) => {
        pdf.text(line, 16, yPosition); // Render the line
        yPosition += lineHeight; // Increment Y-position by line height
      });

      // Set a different color for the second paragraph
      // pdf.setTextColor(0, 0, 255); //color for the second paragraph

      pdf.setFont("Helvetica", "normal");
      pdf.setFontSize(6);

      const secondParagraph =
        "Our commitment to quality extends to our service as well. If, contrary to expectations, you experience any issues with the product, please contact Track and Trail After-Sales Support at 1800-102-2324 or submit the claim form along with this warranty card and the original payment receipt. Alternatively, you can write to us at customercare@trackandtrail.in, customercare@bsahercules.com. Track and Trail reserves the right to either repair or replace the item at its discretion.";

      // Automatically split the text into multiple lines
      const secondLines = pdf.splitTextToSize(secondParagraph, 110);

      // Define line height
      const secondlineHeight = 3; // Adjust line height as needed

      // Render the first paragraph with custom color
      let secondyPosition = 135; // Starting Y-coordinate
      secondLines.forEach((line) => {
        pdf.text(line, 16, secondyPosition); // Render the line
        secondyPosition += secondlineHeight; // Increment Y-position by line height
      });

      // Reset text color for subsequent content
      // pdf.setTextColor(0, 0, 0);
      // pdf.text("Another Text Section", 10, yPosition + 20);

      // Add Title (Warranty Card)
      // pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(28);
      // pdf.setTextColor(0, 0, 0); // Black text color
      // pdf.text("WARRANTY CARD", 70, 30);
      pdf.setTextColor(0, 0, 0); // Back to black color
      // Add Warranty Details
      pdf.setFont("Helvetica", "bold");
      pdf.setFontSize(6);

      // Set label color to gray (128, 128, 128)
      pdf.setTextColor(128, 128, 128);
      pdf.text("Warranty Number:", 16, 90);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(`${card.frameNo}`, 35, 90);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Name:", 16, 94);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(`${card.name}`, 23, 94);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Product Name:", 16, 98);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(`${card.productName}`, 32, 98);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Brand:", 16, 102);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(`${card.brand}`, 23, 102);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Frame Number:", 16, 106);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(`${card.frameNo}`, 33, 106);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("WOW Number:", 16, 110);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(card?.wowNo ? `${card.wowNo}` : "Not Provided", 32, 110);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Date of Purchase:", 16, 114);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(`${formatDate(card.purchaseDate)}`, 35, 114);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Warranty Start Date:", 16, 118);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(`${formatDate(card.purchaseDate)}`, 37, 118);

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Warranty End Date:", 16, 122);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text(
        `${formatDate(
          card?.purchaseDate
            ? new Date(
                new Date(card.purchaseDate).setFullYear(
                  new Date(card.purchaseDate).getFullYear() + 2
                )
              )
                .toISOString()
                .split("T")[0]
            : ""
        )}`,
        36,
        122
      );

      pdf.setTextColor(128, 128, 128);
      pdf.setFont("Helvetica", "bold");
      // pdf.setFontSize(14);
      pdf.text("Brand Website:", 16, 126);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "medium");
      pdf.text("https://www.trackandtrail.in/", 32, 126);

      // Add a section for contact details
      // pdf.setFontSize(8);
      // pdf.text("Thank you for beginning this journey with Track and Trail. Our products are thoughtfully designed with your needs in mind, enabling you to live a fuller and more empowered life. This product is covered by a 2-year warranty from the date of purchase against manufacturing defects. Please note that the warranty does not cover misuse, physical damage, or water ingress.", 10, 160);
      // pdf.text("You can also write to us at customercare@trackandtrail.in or customercare@bsahercules.com", 10, 170);

      // // Add Legal Disclaimer
      // pdf.setFontSize(8);
      // pdf.text("Track and Trail reserves the right to either repair or replace the item at its discretion.", 10, 180);

      isFirstPage = false;
    }

    pdf.save(`warranty-cover-${name}.pdf`);
  };

  if (!Array.isArray(data) || data.length === 0) {
    return <p className="text-black">No warranty data available.</p>;
  }

  return (
    <section className="flex flex-col pb-4">
      <div className="relative w-[18rem] md:w-[26rem] max-h-[240px] p-4 rounded-md">
        {data.map((card, index) => (
          <div
            key={index}
            className="border rounded-lg shadow-md p-4 h-auto bg-white"
          >
            <div className="flex items-center justify-between">
              <img
                src={logo}
                alt="Brand Logo"
                className="w-[100px] md:w-[150px] h-auto z-10"
              />
              <img
                src={curve}
                alt="sidecurve"
                className="absolute w-[180px] h-auto top-[15px] right-4"
              />
            </div>
            <section className="mt-1 flex flex-row gap-6 relative">
              <div className="space-y-2">
                <h2 className="text-[14px] md:text-[18px] font-bold text-black-500">
                  {card.name}
                </h2>
                <p className="text-[10px]">
                  <span className="font-medium">Warranty Number:</span>{" "}
                  {card.frameNo}
                </p>
                <p className="text-[10px]">
                  <span className="font-medium">Product Name:</span>{" "}
                  {card.productName}
                </p>
                <p className="text-[10px]">
                  <span className="font-medium">Brand:</span> {card.brand}
                </p>
                <p className="text-[10px]">
                  <span className="font-medium">Frame No:</span> {card.frameNo}
                </p>
                <p className="text-[10px]">
                  <span className="font-medium">Valid Date:</span>{" "}
                  {formatDate(card.purchaseDate)}
                </p>
              </div>
              <div>
                <div className="absolute right-0 md:right-5 -top-8">
                  <h2 className="relative text-[14px] md:text-[18px] font-bold text-black-500">
                    WARRANTY
                  </h2>
                  <h2 className="relative text-[14px] md:text-[18px] font-bold text-[#7FC241]">
                    CARD
                  </h2>
                </div>
              </div>
            </section>
          </div>
        ))}
      </div>
      <div className="text-end">
        <button
          onClick={() => generatePDF(data[0].name)} // Pass the name of the first item in data to generate PDF
          className="w-32 bg-[#30363e] text-white text-sm px-4 py-2 rounded"
        >
          Download
        </button>
      </div>
    </section>
  );
};

export default RightSideContent;
